import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { CheckIcon, MailIcon, MapPinIcon, MessageCircleIcon, PhoneIcon } from 'lucide-react';
import { Logo } from './Logo';
import { footerColumns, paymentMethods } from '../../data/navigation';
import { contactInfo } from '../../data/home';
export function Footer() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'error' | 'success'>('idle');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!/^\S+@\S+\.\S+$/.test(email)) {
      setStatus('error');
      return;
    }
    setStatus('success');
    setEmail('');
  };
  return <footer className="bg-ink text-white" data-id="element-223" data-mp="3n17xq9ujd7l9">
      <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8" data-id="element-224" data-mp="3j30bizhaze2o">
        <div className="grid gap-10 lg:grid-cols-12" data-id="element-225" data-mp="3e2meech8pojf">
          <div className="lg:col-span-4" data-id="element-226" data-mp="3e24aqus9081h">
            <Logo inverted data-id="element-227" data-mp="3942t8eah0gs4" />
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-white/60" data-id="element-228" data-mp="394ueav6fyw45">
              Thuisbatterijen, powerstations en zonnepanelen voor particulieren en bedrijven in Nederland en België.
            </p>
            <ul className="mt-5 space-y-2 text-sm" data-id="element-229" data-mp="2p4mlzcogx8un">
              <li className="flex items-center gap-2.5" data-id="element-230" data-mp="2bcol1p4wuj9k">
                <PhoneIcon className="h-4 w-4 text-volt" aria-hidden="true" data-id="element-231" data-mp="2be9hxlep6eal" />
                <a href={contactInfo.phoneHref} className="font-semibold hover:underline" data-id="element-232" data-mp="2gcazu30e07kh">
                  {contactInfo.phone}
                </a>
              </li>
              <li className="flex items-center gap-2.5" data-id="element-233" data-mp="382fjfzgboqkn">
                <MessageCircleIcon className="h-4 w-4 text-volt" aria-hidden="true" data-id="element-234" data-mp="381w66w1maqcy" />
                <a href={contactInfo.whatsappHref} target="_blank" rel="noreferrer" className="hover:underline" data-id="element-235" data-mp="2u2eea7t0ywzd">
                  WhatsApp
                </a>
              </li>
              <li className="flex items-center gap-2.5" data-id="element-236" data-mp="1impqje7y5txi">
                <MailIcon className="h-4 w-4 text-volt" aria-hidden="true" data-id="element-237" data-mp="1nmu9dawbv0qw" />
                <a href={`mailto:${contactInfo.email}`} className="hover:underline" data-id="element-238" data-mp="1nkra009abv9i">
                  {contactInfo.email}
                </a>
              </li>
              <li className="flex items-center gap-2.5 text-white/70" data-id="element-239" data-mp="zk74zrzsgw03">
                <MapPinIcon className="h-4 w-4 text-volt" aria-hidden="true" data-id="element-240" data-mp="us5y6lle3xhg" />
                {contactInfo.address}
              </li>
            </ul>
            <form onSubmit={handleSubmit} className="mt-6 max-w-sm" noValidate data-id="element-241" data-mp="pst8lt34wcb6">
              <label htmlFor="newsletter" className="text-sm font-semibold" data-id="element-242" data-mp="kv18ibsc5jvw">
                Aanbiedingen &amp; nieuwe producten in je inbox
              </label>
              <div className="mt-2 flex gap-2" data-id="element-243" data-mp="bta2f5tvvb1i">
                <input id="newsletter" type="email" value={email} onChange={e => {
                setEmail(e.target.value);
                setStatus('idle');
              }} placeholder="jij@email.nl" aria-invalid={status === 'error'} aria-describedby="newsletter-status" className="h-11 min-w-0 flex-1 rounded-lg border border-white/15 bg-ink-soft px-3.5 text-sm text-white placeholder:text-white/40 focus:border-volt focus:outline-none" data-id="element-244" data-mp="bu3d2hvyqkox" />
                <button type="submit" className="h-11 shrink-0 rounded-lg bg-volt px-4 text-sm font-semibold text-ink transition-colors duration-150 hover:bg-volt-hover" data-id="element-245" data-mp="2ijwyvsypi1iv">
                  Aanmelden
                </button>
              </div>
              <p id="newsletter-status" className="mt-2 min-h-[1.25rem] text-xs" aria-live="polite" data-id="element-246" data-mp="1uuc2o8djl7rn">
                {status === 'error' && <span className="text-red-300" data-id="element-247" data-mp="23sxuku4wlz53">Vul een geldig e-mailadres in.</span>}
                {status === 'success' && <span className="inline-flex items-center gap-1 text-volt" data-id="element-248" data-mp="3b798z3nokgva">
                    <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-249" data-mp="3f7t7obnwjsjj" /> Je bent aangemeld.
                  </span>}
              </p>
            </form>
          </div>

          <div className="grid grid-cols-2 gap-8 sm:grid-cols-3 lg:col-span-8 lg:pl-10" data-id="element-250" data-mp="38rufx6goq91r">
            {footerColumns.map(col => <div key={col.title} data-id="element-251" data-mp="3nq4x5arny3v9">
                <h3 className="text-sm font-semibold" data-id="element-252" data-mp="3nqelktx282yu">{col.title}</h3>
                <ul className="mt-4 space-y-2.5" data-id="element-253" data-mp="3ioz6dihkcqod">
                  {col.links.map(l => <li key={l.label} data-id="element-254" data-mp="jcbxvzmanzw">
                      <Link to={l.href} className="text-sm text-white/60 transition-colors duration-150 hover:text-white" data-id="element-255" data-mp="iay5jr7vneh">
                        {l.label}
                      </Link>
                    </li>)}
                </ul>
              </div>)}
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-4 border-t border-white/10 pt-6 md:flex-row md:items-center md:justify-between" data-id="element-256" data-mp="5dglmn09pa4o">
          <ul className="flex flex-wrap gap-2" aria-label="Betaalmethoden" data-id="element-257" data-mp="fa32l0ph3h1f">
            {paymentMethods.map(m => <li key={m} className="rounded-md bg-white px-2.5 py-1 text-xs font-bold text-ink" data-id="element-258" data-mp="xyvpmpjo4p9g">
                {m}
              </li>)}
          </ul>
          <p className="text-xs text-white/50" data-id="element-259" data-mp="ox5wnfa51i9k">© 2026 Ampra Energy B.V. · KvK 81234567 · Prijzen incl. btw</p>
        </div>
      </div>
    </footer>;
}